import { connect } from 'react-redux';

import { RootState } from 'state/reducers';
import {
  selectCurrentStep,
  selectIsValid,
  selectPending,
  selectErrors,
  signUpStepsActions,
} from 'state/signUpSteps';

import SignUpPage from './SignUpPage';

const { UPDATE_VALIDATION, VERIFY_ACCOUNT_REQUEST } = signUpStepsActions;

const mapStateToProps = (state: RootState) => ({
  currentStep: selectCurrentStep(state),
  isValid: selectIsValid(state),
  pending: selectPending(state),
  errors: selectErrors(state),
});

const mapDispatchToProps = {
  updateValidation: UPDATE_VALIDATION,
  verifyAccount: VERIFY_ACCOUNT_REQUEST,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
